(function(){
  function refresh(){document.querySelectorAll('[data-sa-personalization]').forEach(function(box){
    var form=box.closest('form'),notes=box.querySelector('[data-sa-custom-notes]'),data=box.querySelector('[data-sa-personalization-variants]');
    if(!form||!notes||!data)return;
    var variants;try{variants=JSON.parse(data.textContent);}catch(e){return;}
    var select=form.querySelector('[name="id"]'),variant=variants.find(function(v){return String(v.id)===String(select&&select.value);});
    var required=!!(variant&&/custom upgrade/i.test(variant.title));notes.required=required;
    var star=box.querySelector('[data-sa-custom-required]');if(star)star.hidden=!required;
  });}
  document.addEventListener('DOMContentLoaded',refresh);
  document.addEventListener('variant:change',refresh);
  document.addEventListener('change',function(e){if(e.target.closest('.product-single__form'))refresh();});
  document.addEventListener('quickview:loaded',refresh);
  document.addEventListener('submit',function(e){if(e.target.matches('.product-single__form')){refresh();if(!e.target.checkValidity()){e.preventDefault();e.stopImmediatePropagation();e.target.reportValidity();}}},true);
  refresh();
})();

// SereneArgent review dates: shop calendar, not UTC calendar.
(function(){
  var format=new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Hong_Kong',year:'numeric',month:'2-digit',day:'2-digit'});
  function init(){document.querySelectorAll('.sa-product-reviews').forEach(function(region){
    function update(){region.querySelectorAll('time[datetime]').forEach(function(el){
      var date=new Date(el.getAttribute('datetime'));if(isNaN(date.getTime()))return;
      var value=format.format(date);if(el.textContent!==value)el.textContent=value;
    });}
    update();new MutationObserver(update).observe(region,{childList:true,subtree:true});
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
